import { createMutableAction, IBaseMutableAction } from '@bimser/core';
import * as ActionTypes from '../actionTypes';

export function changeDeletedRowIds(
	deletedRowIds: Array<number | string>
): IBaseMutableAction<Array<number | string>> {
	return createMutableAction(ActionTypes.CHANGE_EDITING_DELETED_ROW_IDS, deletedRowIds);
}
